import {
    call,
    put,
    takeEvery,
} from 'redux-saga/effects';
import {
    SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
    SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
    VIEW_PAYMENT_APPROVAL_URL,
    GET_LEAD_PAYMENT_APPROVAL_DATA,
} from '../../constants';
import { SET_MODAL_WINDOW_DATA, CLOSE_MODAL_WINDOW } from '../../../../App/redux/constants/modalWindow.constants';
import { TRANSFER_LEAD_TO_BIKE } from '../../../Lead_profile/redux/constants/final_confirmation.constants';
import { saveLeadFinance as saveLeadFinanceReq, getLeadFinance as getLeadFinanceReq } from '../../requests/leadFinance.requests';
import { message_success, message_error } from '../../../../../components/Message';

function* saveLeadFinance(params) {
    const {
        dataModel,
        op,
        finId,
        sourceScreen,
    } = params;
    let $isNew = false;

    if (sourceScreen === VIEW_PAYMENT_APPROVAL_URL) {
        yield put({ type: SET_MODAL_WINDOW_DATA, payload: { isLoading: true } });
    }

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
        payload: { isLoading: true },
    });

    if (dataModel.tcard) {
        yield put({ type: TRANSFER_LEAD_TO_BIKE, params: { lead_id: dataModel.ref_lead } });
    }

    const data = dataModel.turnInsideOut(op);
    const saveLeadFinRes = yield call(saveLeadFinanceReq, { data, op, finId });
    let newData;

    if (saveLeadFinRes.result) {
        if (sourceScreen === VIEW_PAYMENT_APPROVAL_URL) {
            yield put({ type: CLOSE_MODAL_WINDOW });
            yield put({ type: GET_LEAD_PAYMENT_APPROVAL_DATA, isCount: true });
        }

        const getLeadFinRes = yield call(getLeadFinanceReq, { leadId: saveLeadFinRes.options.ref_lead });
        newData = getLeadFinRes.options;

        dataModel.set(newData);

        message_success('Successfully saved finance information');
    } else {
        console.error(saveLeadFinRes);

        if (sourceScreen === VIEW_PAYMENT_APPROVAL_URL) {
            yield put({ type: SET_MODAL_WINDOW_DATA, payload: { isLoading: false } });
        }

        message_error('Failed save finance information. Please contact to admin');
    }

    if (op === 'Create') {
        $isNew = !saveLeadFinRes.result;
    }

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
        payload: {
            $isNew,
            isLoading: false,
            error: saveLeadFinRes.error,
            dataModel,
            data: newData,
        },
    });
}

export default function* saveLeadFinanceSaga() {
    yield takeEvery(SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, saveLeadFinance);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/redux/sagas/saveLeadFinance.saga.js